import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { intlMessageShape } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import { CSSTransition } from 'react-transition-group';
import Isvg from 'react-inlinesvg';
import { ICONS } from 'constants/icons';
import Message from 'components/Message';
import './Banner.scss';

const ANIMATION_SPEED = 200;
const { block, element } = bem('banner');

const Banner = ({ id, registerBanner, deregisterBanner, className, hideBanner, messageProps, type }) => {
  const [message, setMessage] = useState(messageProps || '');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (messageProps) {
      setMessage(messageProps);
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [messageProps]);

  useEffect(() => {
    registerBanner({ id });
    return () => {
      deregisterBanner({ id });
    };
  }, [id]);

  return (
    <CSSTransition
      className={block(className)}
      classNames={block()}
      in={visible}
      onExited={hideBanner}
      timeout={ANIMATION_SPEED}
      mountOnEnter
      unmountOnExit>
      <div>
        <div
          className={element('wrapper', {
            info: type === 'info',
            error: type === 'error',
          })}>
          <Message as="div" className={element('message')} message={message} />
          <button className={element('close-button')} type="button" onClick={() => setVisible(false)}>
            <Isvg src={ICONS.cross} />
          </button>
        </div>
      </div>
    </CSSTransition>
  );
};

Banner.propTypes = {
  className: PropTypes.string,
  deregisterBanner: PropTypes.func,
  hideBanner: PropTypes.func,
  id: PropTypes.string.isRequired,
  messageProps: PropTypes.shape({
    ...intlMessageShape,
    values: PropTypes.shape({}), // could be almost any shape
  }),
  registerBanner: PropTypes.func,
  type: PropTypes.oneOf(['info', 'error']),
};

export default Banner;
